import styled from "@emotion/styled"
import moment from "moment"
import { formatMoney } from "../general/utils"
import { MDBCol, MDBContainer, MDBRow, MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit"

const StyledComponent = styled(MDBContainer)`
    padding: 0; 
    margin: 20px;
    font-size: 14px !important;
    & p {
        margin: 0;
        font-size: 14px !important;
    }
    & h6 {
        font-size: 14px !important;
    }
`

interface IProps {
  items: any[]
  nombreProyecto: string
}

interface ReportRow {
  medio: string
  concepto: string
  descripcion: string
  presupuesto: number
  monto: number
  disponible: number
}

type Header = {
  label: string
  name: keyof ReportRow
  customItem?: (row: ReportRow) => React.ReactNode
}

const headers: Header[] = [
  { label: "Medio", name: "medio" },
  { label: "Concepto", name: "concepto" },
  { label: "Descripción", name: "descripcion" },
  {
    label: "SUM Presupuesto",
    name: "presupuesto",
    customItem: (row: any) => formatMoney(row.presupuesto),
  },
  {
    label: "SUM Monto",
    name: "monto",
    customItem: (row: any) => formatMoney(row.monto),
  },
  {
    label: "Disponible",
    name: "disponible",
    customItem: (row: any) => formatMoney(row.disponible),
  },
]

const toNumber = (value: any) => Number(value || 0)

const calcularPresupuestoItem = (item: any) =>
  toNumber(item.cantidad) *
  toNumber(item.repeticion) *
  toNumber(item.precioUnitario)

const calcularMontoRequisiciones = (item: any) =>
  (item.requisiciones || []).reduce((acc: number, req: any) => {
    return (
      acc +
      toNumber(req.cantidadRequisicion) *
      toNumber(req.repeticionRequisicion) *
      toNumber(req.costoRequisicion)
    )
  }, 0)

const buildReportRows = (items: any[]): ReportRow[] =>
  items.map((item) => {
    const presupuesto = calcularPresupuestoItem(item)
    const monto = calcularMontoRequisiciones(item)

    return {
      medio: item.medioLabel,
      concepto: item.conceptoLabel,
      descripcion: item.descripcion || "-",
      presupuesto,
      monto,
      disponible: presupuesto - monto,
    }
  })

const ComponentCaratulaCampana = ({ items, nombreProyecto }: IProps) => {
  const today = moment()
  const rows = buildReportRows(items)

  const totalPresupuesto = rows.reduce((acc, r) => acc + r.presupuesto, 0)
  const totalMonto = rows.reduce((acc, r) => acc + r.monto, 0)
  const totalDisponible = totalPresupuesto - totalMonto

  return (
    <StyledComponent>
      {/* Header */}
      <MDBRow style={{ margin: "40px 20px" }}>
        <MDBCol>
          <h5 className="fw-bold">Carátula de la Campaña</h5>
          <p><strong>Proyecto:</strong> {nombreProyecto}</p>
          <p><strong>Fecha:</strong> {today.format("LL")}</p>
        </MDBCol>
      </MDBRow>

      {/* Tabla */}
      <MDBRow style={{ margin: "20px" }}>
        <MDBCol>
          <MDBTable bordered>
            <MDBTableHead>
              <tr>
                {headers.map(({ label, name }) => (
                  <th key={name}>{label}</th>
                ))}
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {rows.map((row, index) => (
                <tr key={index}>
                  {headers.map(({ name, customItem }) => {
                    // console.log("customItem: ", {name, customItem})
                    return (
                    <td key={name}>
                      { customItem ? customItem(row) : row[name]}
                    </td>
                  )})}
                </tr>
              ))}

              {/* Totales */}
              <tr style={{ fontWeight: "bold", background: "#f5f5f5" }}>
                <td colSpan={3}>Totales</td>
                <td>{formatMoney(totalPresupuesto)}</td>
                <td>{formatMoney(totalMonto)}</td>
                <td>{formatMoney(totalDisponible)}</td>
              </tr>
            </MDBTableBody>
          </MDBTable>
        </MDBCol>
      </MDBRow>
    </StyledComponent>
  )
}

export default ComponentCaratulaCampana;